// Saves a file the browser already holds (a data or object URL) under `filename`.
export function downloadUrl(url: string, filename: string) {
  const a = document.createElement('a');
  a.download = filename;
  a.href = url;
  a.click();
}
